export const HOW_IT_WORKS_CARDS = [
  {
    label: '1. Issue e-prescriptions for your patients anytime from anywhere. Completely free-of-charge',
    image: '/images/cards/employee.png',
  },
  {
    label: '2. Our partner pharmacies and logistics network will fulfil the prescription order immediately',
    image: '/images/cards/board.png',
  },
  {
    label: '3. Medication delivered to the patient within 2h in central London (and 24h UK-wide)',
    image: '/images/cards/box.png',
  },
];

export const OFFER_CARDS = [
  {
    title: 'Extensive product range',
    description: 'We partner with independent and chain pharmacies to bring you over 3,000 products, from meds  to first aid and skincare',
    image: '/images/patients/meds.png',
  },
  {
    title: 'Private prescriptions',
    description: 'Receive medication for the most commonly prescribed symptoms and conditions via in-app questionnaires which will be reviewed by our prescribing pharmacist',
    image: '/images/patients/receipt.png',
  },
  {
    title: 'Rapid delivery',
    description: 'We understand that time can be critical when it comes to your health and well-being, which is why we deliver orders within 2 hours in (inner) London ad within 24hrs across the rest of the UK',
    image: '/images/patients/timer.png',
  },
  {
    title: 'Great customer support',
    description: 'Our attentive customer support team is on hand for any order issues or other concerns',
    image: '/images/patients/messages.png',
  },
];
